import React from 'react'
import BooksDetail from '../books/BooksDetail'
import { ELibraryCategory } from '../../enum/elibrary_enum'
import { routeName } from '../../../../routes/routeName'

type Props = {}

const VideoDetail: React.FC<Props> = (props: Props) => {
    return (
        <BooksDetail
            library_head_name='วีดีโอ'
            library_category={ELibraryCategory.VIDEO}
            library_head_pathname={routeName.e_library.video}
            library_head_list_path={routeName.e_library.video_list}
        />
    )
}

export default VideoDetail